import Swiper from "swiper";
import { find } from "utils/dom";
import { gsap } from "gsap";

export default function () {
	const Single = find("[js-page='work']");
	if (!Single) return;

	document.addEventListener('DOMContentLoaded', function () {

        const swiperDevelopment = new Swiper('.swiper-development', {
            slidesPerView: '3.5', 
            centeredSlides: false,
            spaceBetween: 20,
            grabCursor: true,
            
            breakpoints: {
                768: {
					 slidesPerView: 'auto', 
                    spaceBetween: 20, 
                },
                1024: {
					 slidesPerView: 'auto', 
                    spaceBetween: 20, 
                }
            }
        });



		const swiperValues = new Swiper('.swiper-values', {
			slidesPerView: 'auto',
			centeredSlides: false,
			speed:1000,
			spaceBetween: 20,
			navigation: {
				nextEl: '.work-values-container .values-button-next',
				prevEl: '.work-values-container .values-button-prev',
			},
			pagination: { 
        el: '.swiper-pagination-values',
				type: 'fraction',
				formatFractionCurrent: (number) => number.toString(),
				formatFractionTotal: (number) => number.toString()
			},
			breakpoints: {
				768: { 
					slidesPerView: 3
				}
			}	
		});

		const swiperWorkLeft = new Swiper('.swiper-work-testimonial-left', {
			spaceBetween: 12,
			slidesPerView: 'auto',
			loop: true,
			speed: 20000,
	
			autoplay: {
				delay: 1,
				disableOnInteraction: false
			},

			breakpoints: {
				768: {
					spaceBetween: 24,
				}
			},	

		})

		const swiperWorkRight = new Swiper('.swiper-work-testimonial-right', {
			spaceBetween: 12,
			slidesPerView: 'auto',
			loop: true,
			speed: 20000,
	
			autoplay: {
				delay: 1,
				disableOnInteraction: false,
				reverseDirection: true
			},

			breakpoints: {
				768: {
					spaceBetween: 24,
				}
			},	

		})

		const observer = new MutationObserver((mutationsList) => {
			mutationsList.forEach(mutation => {
				mutation.addedNodes.forEach(node => {
					if (node.nodeType === 1 && node.classList.contains('fancybox__backdrop')) {
						node.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
					}
				});
			});
		});
	
		observer.observe(document.body, { childList: true, subtree: true });

	});

	document.addEventListener('DOMContentLoaded', () => {
		const progress = document.querySelector('.progress');
		const counter = document.querySelector('.counter');
		const head = document.querySelector('.progress-head')
		const container = document.querySelector('.work-progression-bar');
		const radius = 45
		const circumference = 2 * Math.PI * radius;
		
		progress?.parentElement.appendChild(head);
		
		gsap.set(progress, { attr: { "stroke-dasharray": circumference, "stroke-dashoffset": circumference } });
		
		const updateHead = () => {
			const current = 1 - (Number(progress.getAttribute("stroke-dashoffset")) / circumference);
			const angle = (0 + 360 * current) * (Math.PI / 180);
			head.setAttribute("cx", 50 + radius * Math.cos(angle));
			head.setAttribute("cy", 50 + radius * Math.sin(angle));
		};
		

		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
					gsap.to(progress, {
						duration: 3.5,
						ease: "power2.out",
						attr: { "stroke-dashoffset": circumference * 0.25 },
						onUpdate: updateHead
					});
					counterUp.default(counter, { duration: 2300, delay: 10 });
					entry.target.classList.add('animated');
				}
			});
		}, { threshold: 0.5 });
		
		observer.observe(container);
	});
}
